module.exports = __webpack_public_path__ + "img/3.adfff35c.jpg";